export default {
  'completeprofile.completeprofile': 'НАЧАТЬ ПОЛНЫЙ ПРОЦЕСС ПРОФИЛЯ',
  'completeprofile.maintext':
    'Чтобы завершить ваш анкет и получить свои баллы, пожалуйста, попробуйте заполнить свой анкет и нажамите на Совершить анкет',
};
